let actions = {
    setIsShowGenduPopup: (context, data) => {
        context.commit('setIsShowGenduPopup', data);
    },
    setIsShowWendaPopup: (context, data) => {
        context.commit('setIsShowWendaPopup', data);
    },
    setLastShow: (context, data) => {
        context.commit('setLastShow', data);
    }
}
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/habitLower/actions.js